import {REPORT_BUSINESS_BUILDER_COACHES} from '/enum/records.enum';

export default {
  reportName: REPORT_BUSINESS_BUILDER_COACHES,
};
